/* Progressive enhancement: native selects, search and cart forms remain the fallback. */
(() => {
  let refreshVersion = 0;
  async function refreshCart() {
    const version = ++refreshVersion;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== refreshVersion) return;
      document.querySelectorAll('[data-cart-icon]').forEach(icon => {
        icon.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
        const badge = icon.querySelector('[data-cart-count]');
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
      });
    } catch (_) { /* Keep the server-rendered count when offline; never retry an add. */ }
  }
  document.addEventListener('cart:updated', refreshCart);
  window.addEventListener('pageshow', refreshCart);
  window.ssCartFly = (product, button) => {
    const header = document.querySelector('[data-cart-icon]');
    if (!header) return;
    const modal = product.closest('dialog');
    const bounds = header.getBoundingClientRect();
    const temporary = modal || bounds.bottom < 0 || bounds.top >= innerHeight;
    const layer = document.createElement('div');
    layer.setAttribute('popover', 'manual');
    layer.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;border:0;background:transparent;overflow:visible;pointer-events:none;z-index:2147483647';
    (modal || document.body).append(layer);
    if (layer.showPopover) layer.showPopover();
    let target = header;
    if (temporary) {
      target = header.cloneNode(true);
      target.className = '';
      target.style.cssText = 'position:fixed;right:20px;top:max(20px,env(safe-area-inset-top));width:46px;height:46px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:#fff;color:#111827;box-shadow:0 4px 20px #0003;pointer-events:auto';
      layer.append(target);
    }
    const destination = target.getBoundingClientRect();
    const source = product.querySelector('[data-main-image]');
    if (source && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let start = source.getBoundingClientRect();
      if (start.bottom <= 0 || start.top >= innerHeight) start = (button || product).getBoundingClientRect();
      const thumbnail = document.createElement('img');
      thumbnail.src = source.currentSrc || source.src;
      thumbnail.alt = '';
      thumbnail.style.cssText = 'position:fixed;width:64px;height:64px;object-fit:cover;border-radius:12px;box-shadow:0 4px 16px #0003;pointer-events:none';
      const x = Math.max(32, Math.min(innerWidth - 32, start.left + start.width / 2));
      const y = Math.max(32, Math.min(innerHeight - 32, start.top + start.height / 2));
      thumbnail.style.left = (x - 32) + 'px';
      thumbnail.style.top = (y - 32) + 'px';
      layer.append(thumbnail);
      const dx = destination.left + destination.width / 2 - x;
      const dy = destination.top + destination.height / 2 - y;
      thumbnail.animate([
        {transform: 'translate(0,0) scale(1)', opacity: 1},
        {transform: `translate(${dx * .45}px,${dy * .45 - 60}px) scale(.75)`, opacity: .95, offset: .45},
        {transform: `translate(${dx}px,${dy}px) scale(.15)`, opacity: 0}
      ], {duration: 650, easing: 'ease-in-out', fill: 'forwards'});
    }
    setTimeout(() => layer.remove(), temporary ? 2800 : 750);
  };
})();
document.querySelectorAll('[data-address-country]').forEach(country=>{
  const province=country.closest('form').querySelector('[data-address-province]');
  const update=()=>{
    let provinces=[];try{provinces=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');}catch(e){/* Shopify normally supplies this JSON. */}
    province.replaceChildren(...provinces.map(([value,label])=>new Option(label,value)));
    province.closest('label').hidden=!provinces.length;
    if(province.dataset.default)province.value=province.dataset.default;
  };
  if(country.dataset.default)country.value=country.dataset.default;
  country.addEventListener('change',update);update();
});
document.querySelectorAll('.ss-account details').forEach(details=>{
  if(details.querySelector('.errors,[role=status]'))details.open=true;
});
if(location.hash==='#recover'){const recover=document.querySelector('#recover');if(recover)recover.open=true;}
if (!customElements.get('ss-select')) {
  customElements.define('ss-select', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('details')) return;
      const select = this.querySelector('select');
      if (!select) return;
      const label = document.getElementById(select.getAttribute('aria-labelledby'))?.textContent.trim() || select.labels?.[0]?.childNodes[0]?.textContent.trim() || '';
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const list = document.createElement('div');
      list.className = 'ss-select__options';
      details.append(summary, list);
      const sync = () => {
        summary.textContent = select.selectedOptions[0]?.textContent || '';
        summary.setAttribute('aria-label', label + ': ' + summary.textContent);
        list.querySelectorAll('button').forEach((button, i) => button.setAttribute('aria-pressed', String(select.selectedIndex === i)));
      };
      Array.from(select.options).forEach((option, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = option.textContent; button.disabled = option.disabled;
        button.addEventListener('click', () => {
          select.selectedIndex = i; sync(); details.open = false; summary.focus();
          select.dispatchEvent(new Event('change', {bubbles:true}));
        });
        list.append(button);
      });
      details.addEventListener('keydown', e => {
        if (e.key === 'Escape') { details.open = false; summary.focus(); e.stopPropagation(); }
        const buttons = [...list.querySelectorAll('button:not(:disabled)')];
        if (['ArrowDown','ArrowUp','Home','End'].includes(e.key) && buttons.length) {
          e.preventDefault(); details.open = true;
          let i = buttons.indexOf(document.activeElement);
          i = e.key === 'Home' ? 0 : e.key === 'End' ? buttons.length-1 : (i + (e.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[i].focus();
        }
      });
      details.addEventListener('focusout', () => setTimeout(() => {if(!details.contains(document.activeElement))details.open=false;},0));
      select.addEventListener('change', sync);
      select.hidden = true; this.append(details); sync();
    }
  });
}

(() => {
  const panel = document.querySelector('#SSSearch');
  if (!panel) return;
  const input = panel.querySelector('input[name=q]');
  const results = panel.querySelector('[data-search-results]');
  const status = panel.querySelector('[data-search-status]');
  let controller, timer, opener, version = 0;
  const position = () => {
    const header = document.querySelector('.ss-site-header');
    const bottom = header?.getBoundingClientRect().bottom || 0;
    panel.style.setProperty('--search-top', Math.max(0,Math.min(bottom,innerHeight-160))+'px');
  };
  const close = () => { ++version;clearTimeout(timer);controller?.abort();panel.close();opener?.focus(); };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href,location.origin);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/,'') !== panel.dataset.searchUrl.replace(/\/$/,'')) return;
    event.preventDefault();opener=link;position();if(!panel.open)panel.showModal();input.focus();
  });
  panel.querySelector('[data-search-close]').addEventListener('click',close);
  panel.addEventListener('cancel',e=>{e.preventDefault();close();});
  panel.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();close();}});
  panel.addEventListener('click',e=>{if(e.target===panel){const r=panel.getBoundingClientRect();if(e.clientY<r.top||e.clientY>r.bottom)close();}});
  window.addEventListener('resize',position);
  window.addEventListener('scroll',()=>{if(panel.open)position();},{passive:true});
  async function search(href) {
    clearTimeout(timer);controller?.abort();const current=++version;
    if(!input.value.trim()){results.replaceChildren();status.textContent='';return;}
    controller=new AbortController();const signal=controller.signal;
    const url=new URL(href||panel.dataset.searchUrl,location.origin);
    url.searchParams.set('q',input.value.trim());url.searchParams.set('type','product,page,article');url.searchParams.set('view','songsong-results');
    const preview=new URL(location.href).searchParams.get('preview_theme_id')||(window.Shopify?.designMode?window.Shopify?.theme?.id:null);
    if(preview)url.searchParams.set('preview_theme_id',preview);
    status.textContent=panel.dataset.loading;results.setAttribute('aria-busy','true');
    try {
      const response=await fetch(url,{signal});if(!response.ok)throw new Error('search');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const feed=doc.querySelector('[data-search-feed]');if(!feed)throw new Error('feed');
      if(current!==version)return;
      results.innerHTML=feed.innerHTML;
      status.textContent=results.querySelector('.ss-search-result')?'':panel.dataset.empty;
    } catch(error) {if(error.name!=='AbortError'&&current===version)status.textContent=panel.dataset.error;}
    finally {if(current===version)results.removeAttribute('aria-busy');}
  }
  input.addEventListener('input',()=>{++version;controller?.abort();clearTimeout(timer);results.replaceChildren();results.removeAttribute('aria-busy');timer=setTimeout(()=>search(),300);});
  panel.querySelector('form').addEventListener('submit',e=>{e.preventDefault();search();});
  results.addEventListener('click',e=>{const a=e.target.closest('.ss-pagination a');if(a){e.preventDefault();search(a.href);}});
})();
